// Redux Reducers
import SET_ALLOW_ACCESS, {
  SET_API,
  API_PATCH_ENDPOINT,

  SET_BACKEND,

  SET_CONNECT,
  SET_SUBSCRIPTION,
  ADD_FREEMIUM_TRACKS_LOAD,
  SET_USER,
  SET_USER_PARAMETER,
  SET_AUTH,
  SET_AUTH_RESPONSE,
  SET_AUTH_STORE,
  SET_LINKAGE,
  SET_PRO_PLUS,

  SET_REGISTRATION,

  SET_ROUTE_STORE,

  SET_DIMENSION,

  SET_STORE_PLAYLISTS,
  SORTABLE_STORE_PLAYLISTS,
  NEW_STORE_PLAYLISTS,
  NEW_LOCAL_STORE_PLAYLISTS,
  UPDATE_STORE_PLAYLISTS,
  PUSH_STORE_PLAYLISTS,
  REMOVE_STORE_PLAYLISTS,
  INC_STORE_PLAYLISTS,
  SET_EXTRA_PLAYLISTS,
  ADD_EXTRA_PLAYLISTS,
  REFRESH_STORE_PLAYLISTS,
  SAVE_LOCAL_PLAYLIST,
  SET_PLAYLIST_TRACKS_ADDED,

  SET_STORE_HISTORY,
  UPDATE_STORE_HISTORY,
  HISTORY_PREV,
  HISTORY_NEXT,

  SET_STORE_LIST,
  SET_SELECTED_ITEMS,
  ADD_SELECTED_ITEMS,
  UNSELECTED_ITEMS,
  ADD_DRAG_ITEMS,
  CLEAR_DRAG_ITEMS,
  SET_DROPBOX,
  CLEAR_DROPBOX,

  SET_MODAL,
  SET_CONTEXT_MENU,

  SET_HISTORY_TRACKS,
  ADD_HISTORY_TRACKS,
  REMOVE_HISTORY_TRACKS,
  CLEAR_HISTORY_TRACKS,

  SET_ONAIR,

  SET_PLAYER_PREVIEW,
  SET_AUDIO_PREVIEW,
  SET_POSITION_PREVIEW,

  ADD_REPLAY_TRACKS,
  SET_REPLAY_TRACKS,

  SET_TICK_ITEM_ID,
  SET_CURRENT_LIST_BOUNDARIES,

  SET_DRAG_PLAYER,
  SET_STATE_SCROLLING,
  SET_STATE_FULLSCREEN,
  SET_STATE_CLEAR_FILTERS,
  SET_READY_BOOST_FILTERS,
  SET_LIST_CONTAINER_REF,

  SET_REQUEST_ERROR,
  SET_FIRST_LOG,

  /** TOUCH **/
  SET_LAYOUT_TABLET,
  TOGGLE_LAYOUT_TABLET,
  SET_TOUCH_EDITOR,

  /** TOAST **/
  ADD_TOAST,
  REMOVE_TOAST,

  /** POPUP **/
  SET_POPUP,
  SET_STORE_POPUP,

  /** TAB BAR **/
  SET_TAB_BAR,
  RESET_TAB_BAR,

  /** SPLASH **/
  SET_SPLASH_STATE,
  SET_SPLASH_LOADING,
  SET_SPLASH_ERROR,

  SET_BROWSER_OPTIMAL,
  SET_BANNER_BROWSER

} from "../types";

import { HISTORY_V2 } from "../config";

const initialState = {
  api: null,

  backend: `html5`,

  isConnected: false,
  isSubscribed: false,
  freemiumTracksLoad: 0,
  user: null,
  auth: null,
  authResponse: null,
  storeAuth: null,
  isProPlus: false,
  isLinkage: true,

  registration: null,

  storeRoute: null,
  dimension : { isOpen: true, parentWidth: 0, width: 500, height: 0 },

  storePlaylists: {},
  lastPlaylistUpdated: null,
  lastPlaylistPushed: null,
  lastPlaylistIncremented: null,
  lastPlaylistSorted: null,
  playlistTracksAdded: null,
  extraPlaylists: [],
  storeHistory: {},
  pendingHistoryPath: null,
  history: [{ path: window.location.pathname || `/`, active: true }], // V2
  storeList: null,
  selectedItems: [],
  modal: { title: null, description: null, content: null, active: false, enableHeader: false, underlayClickExits: true },
  contextMenu: [],
  contextMenuOptions: null,
  historyTracks: [],
  dragItems: [],
  dropboxElement: null,

  onAir: [null, null],

  playerPreview: null,
  audioPreview: null,
  positionPreview: { idParent: null, position: 0 },
  storePreview: {},

  replayTracks: [],

  tickItemID: null,
  currentListBoundaries: null,
  listContainerRef: null,

  deckItemA: null,
  deckItemB: null,

  isScrolling: false,
  isFullScreen: false, // Use now for Automix,
  showClearFilters: false,
  isReadyBoostFilters: false,

  error: null,
  isFirstLog: false,

  /** TOUCH **/
  layoutTablet: false,
  touchEditor: false,

  /** TOAST **/
  toasts: [], // { content: null, duration: 2500 },

  /** POPUP **/
  popup: { content: null },
  storePopup: {},

  /** GENERAL **/
  allowAccess: false,

  /* TAB BAR */
  tabBar: { left: null, right: null },

  /* SPLASH */
  splashState: true,
  splashLoading: 20,

  isBrowserOptimal: true,
  bannerBrowser: false
};

function rootReducer(state = initialState, action) {

  /** API **/

  if (action.type === SET_API) {
    return { ...state, api: { ...action.payload } }
  }

  if (action.type === API_PATCH_ENDPOINT) {
    const api = state.api;
    if (api && api.patch) {
      api.patch(action.endpoint, action.value);
    }
    return { ...state }
  }

  /** BACKEND **/

  if (action.type === SET_BACKEND) {
    return { ...state, backend: action.payload }
  }

  /** AUTHENTIFICATION **/

  if (action.type === SET_CONNECT) {
    return { ...state, isConnected: action.payload }
  }

  if (action.type === SET_SUBSCRIPTION) {
    return { ...state, isSubscribed: action.payload }
  }

  if (action.type === ADD_FREEMIUM_TRACKS_LOAD) {
    return { ...state, freemiumTracksLoad: state.freemiumTracksLoad + 1 }
  }

  if (action.type === SET_AUTH) {
    return { ...state, auth: action.payload }
  }

  if (action.type === SET_USER) {
    return { ...state, user: action.payload }
  }

  if (action.type === SET_USER_PARAMETER) {
    let userState = state.user;
    userState[action.parameter] = action.value;
    return { ...state, user: userState }
  }

  if (action.type === SET_AUTH_RESPONSE) {
    return { ...state, authResponse: action.payload }
  }

  if (action.type === SET_AUTH_STORE) {
    return { ...state, storeAuth: action.payload }
  }

  if (action.type === SET_PRO_PLUS) {
    return { ...state, isProPlus: action.payload }
  }

  if (action.type === SET_LINKAGE) {
    return { ...state, isLinkage: action.payload }
  }

  /** REGISTRATION **/

  if (action.type === SET_REGISTRATION) {
    return { ...state, registration: action.payload }
  }

  /** ROUTE **/

  if (action.type === SET_ROUTE_STORE) {
    return { ...state, storeRoute: action.payload }
  }

  /** DIMENSION **/

  if (action.type === SET_DIMENSION) {
    return { ...state, dimension: { ...action.payload } }
  }

  // REMOVED
  // if (action.type === OPEN_DRAWER) {
  //   if (window.sidebar_toggle && state.dimension && !state.dimension.fullHeight) {
  //     setTimeout(() => { window.sidebar_toggle(); }, 100); // NOT THE BEST
  //   }
  //   return { ...state }
  // }

  /** PLAYLISTS **/

  if (action.type === SET_STORE_PLAYLISTS) {
    return { ...state, storePlaylists: { ...action.payload } }
  }

  if (action.type === SORTABLE_STORE_PLAYLISTS) {
    // side-channel (concurrent-safe)
    return { ...state, lastPlaylistSorted: { trackID: action.trackID, endIndex: action.endIndex, at: Date.now() } }
    //state.storePlaylists.sortable(action.trackID, action.endIndex)
    //return { ...state }
  }

  if (action.type === NEW_STORE_PLAYLISTS) {
    state.storePlaylists.new(action.name, action.data, action.extra);
    return { ...state }
  }

  if (action.type === SAVE_LOCAL_PLAYLIST) {
    const playlist = state.storePlaylists.get(action.id);
    if (playlist) {
      state.storePlaylists.new(action.name, playlist.tracks, action.extra);
    }
    return { ...state }
  }

  if (action.type === NEW_LOCAL_STORE_PLAYLISTS) {
    const playlist = state.storePlaylists.get(action.id);
    if (!playlist) {
      state.storePlaylists.newLocal(action.id, action.name, action.data, action.extra);
    }
    return { ...state }
  }

  if (action.type === UPDATE_STORE_PLAYLISTS) {
    return { ...state, lastPlaylistUpdated: { id: action.trackID, property: action.property, data: action.data } }
  }

  if (action.type === PUSH_STORE_PLAYLISTS) {
    return { ...state, lastPlaylistPushed: { id: action.trackID, property: action.property, data: action.data, at: Date.now() } }
  }

  if (action.type === INC_STORE_PLAYLISTS) {
    return { ...state, lastPlaylistIncremented: { id: action.trackID, property: action.property, data: action.data, at: Date.now() } }
  }

  if (action.type === REMOVE_STORE_PLAYLISTS) {
    state.storePlaylists.remove(action.trackID);
    return { ...state }
  }

  if (action.type === SET_EXTRA_PLAYLISTS) { //From YOUDJ
    return { ...state, extraPlaylists: action.extra }
  }

  if (action.type === ADD_EXTRA_PLAYLISTS) { //From YOUDJ
    return { ...state, extraPlaylists: [...state.extraPlaylists, action.extra] }
  }

  if (action.type === REFRESH_STORE_PLAYLISTS) {
    if (state.storePlaylists && !state.enablePM) {
      state.storePlaylists.refresh(new Date());
    }
    return { ...state }
  }

  if (action.type === SET_PLAYLIST_TRACKS_ADDED) {
    return { ...state, playlistTracksAdded: { id: action.id, at: Date.now() } }
  }

  /** HISTORY - NAVIGATOR **/

  if (action.type === SET_STORE_HISTORY) {
    return { ...state, storeHistory: { ...action.payload } }
  }

  //V1
  // if (action.type === UPDATE_STORE_HISTORY) {
  //   if (state.storeHistory.updateHistory)
  //     setTimeout(() => state.storeHistory.updateHistory(action.path), 100);
  //   return { ...state }
  // }
  if (action.type === UPDATE_STORE_HISTORY) {
    if (HISTORY_V2) {
      const i = state.history.findIndex(x => x.active);
      const kept = state.history.slice(0, i + 1).map(x => ({ ...x, active: false }));
      return { ...state, history: [...kept, { path: action.path, active: true }] }
    }
    return { ...state, pendingHistoryPath: { path: action.path, at: Date.now() } } // V1
  }

  if (action.type === HISTORY_PREV) {
    const i = state.history.findIndex(x => x.active) - 1;
    return { ...state, history: state.history.map((x, idx) => ({ ...x, active: idx === i })) }
  }

  if (action.type === HISTORY_NEXT) {
    const i = state.history.findIndex(x => x.active) + 1;
    return { ...state, history: state.history.map((x, idx) => ({ ...x, active: idx === i })) }
  }

  /** SELECTED ITEMS **/

  if (action.type === SET_STORE_LIST) {
    return { ...state, storeList: { ...action.payload } }
  }

  if (action.type === SET_SELECTED_ITEMS) {
    return { ...state, selectedItems: [...action.payload] }
  }

  if (action.type === ADD_SELECTED_ITEMS) {
    const item = state.selectedItems.find( x => x.id === action.payload.id);
    return  (item) ? { ...state } : { ...state, selectedItems: [ ...state.selectedItems, action.payload] }
  }

  if (action.type === UNSELECTED_ITEMS) {
    return { ...state, selectedItems: [] }
  }

  if (action.type === ADD_DRAG_ITEMS) {
    return { ...state, dragItems: [...state.selectedItems] }
  }

  if (action.type === CLEAR_DRAG_ITEMS) {
    return { ...state, dragItems: [] }
  }

  if (action.type === SET_DROPBOX) {
    return { ...state, dropboxElement: action.payload }
  }

  if (action.type === CLEAR_DROPBOX) {
    if (state.dropboxElement !== null)
      state.dropboxElement.style.opacity = 0;
    return { ...state, dropboxElement: null }
  }
  

  /** MODAL **/

  if (action.type === SET_MODAL) {
    const base = (action.payload) ? {
      enableHeader: false,
      active: true,
      underlayBackground: `rgba(36, 36, 36, 0.8)`
    } : {}
    return { ...state, modal: { ...base, ...action.payload } }
  }

  /** CONTEXT MENU **/

  if (action.type === SET_CONTEXT_MENU) {
    return { ...state, contextMenu: [...action.payload], contextMenuOptions: action.options }
  }

  /** HISTORY TRACKS **/

  if (action.type === SET_HISTORY_TRACKS) {
    return { ...state, historyTracks: [...action.payload] }
  }

  if (action.type === ADD_HISTORY_TRACKS) {
    return { ...state, historyTracks: [action.payload, ...state.historyTracks] }
  }

  if (action.type === REMOVE_HISTORY_TRACKS) {
    let tracks = [...state.historyTracks];
    const index = tracks.findIndex( x => x.id === action.trackID)
    tracks.splice(index, 1);
    return { ...state, historyTracks: [...tracks] }
  }

  if (action.type === CLEAR_HISTORY_TRACKS) {
    return { ...state, historyTracks: [] }
  }

  /** ON AIR **/

  if (action.type === SET_ONAIR) {
    let newOnAir = [...state.onAir];
    newOnAir[action.pid - 1] = action.trackID;
    return { ...state, onAir: [...newOnAir] };
  }

  /** PREVIEW **/

  if (action.type === SET_PLAYER_PREVIEW) {
    return { ...state, playerPreview: action.player }
  }

  if (action.type === SET_AUDIO_PREVIEW) {
    return { ...state, audioPreview: action.audio }
  }

  if (action.type === SET_POSITION_PREVIEW) {
    return { ...state, positionPreview: { idParent: action.idParent, position: action.position } }
  }

  /** REPLAY **/

  if (action.type === ADD_REPLAY_TRACKS) {
    return { ...state, replayTracks: [action.trackID, ...state.replayTracks] }
  }

  if (action.type === SET_REPLAY_TRACKS) {
    return { ...state, replayTracks: action.tracks }
  }

  /** LIST **/

  if (action.type === SET_TICK_ITEM_ID) {
    return { ...state, tickItemID: action.payload }
  }

  if (action.type === SET_CURRENT_LIST_BOUNDARIES) {
    return { ...state, currentListBoundaries: action.payload }
  }


  /** D&D **/

  if (action.type === SET_DRAG_PLAYER) {
    if (action.pid === 1) {
      return { ...state, deckItemA: action.audio }
    } else if (action.pid === 2) {
      return { ...state, deckItemB: action.audio }
    } else {
      return { ...state };
    }
  }

  if (action.type === SET_STATE_SCROLLING) {
    return { ...state, isScrolling: action.payload }
  }

  if (action.type === SET_STATE_FULLSCREEN) {
    return { ...state, isFullScreen: action.payload }
  }

  if (action.type === SET_STATE_CLEAR_FILTERS) {
    return { ...state, showClearFilters: action.payload }
  }

  if (action.type === SET_READY_BOOST_FILTERS) {
    return { ...state, isReadyBoostFilters: action.payload }
  }

  if (action.type === SET_LIST_CONTAINER_REF) {
    return { ...state, listContainerRef: action.payload }
  }

  /** Errors **/

  if (action.type === SET_REQUEST_ERROR) {
    return { ...state, error: action.payload }
  }

  if (action.type === SET_FIRST_LOG) {
    return { ...state, isFirstLog: action.payload }
  }

  /** TABLET **/

  /** TOUCH **/

  if (action.type === SET_LAYOUT_TABLET) {
    return { ...state, layoutTablet: action.payload }
  }

  if (action.type === TOGGLE_LAYOUT_TABLET) {
    const newState = !state.layoutTablet;
    if (window.getdiv) {
      window.getdiv("alpha2").style.height = newState ? '460px' : '316px';
      window.getdiv("alpha2b").style.height = newState ? '366px' : '221px';
      window.getdiv("player").style.height = newState ? '460px' : '316px';
      (window.window_resize) && window.window_resize();
    }
    (window['YouDJ'] && window['YouDJ'].set_layout_tablet) && window['YouDJ'].set_layout_tablet(newState);
    return { ...state, layoutTablet: newState }
  }

  if (action.type === SET_TOUCH_EDITOR) {
    return { ...state, touchEditor: action.payload }
  }

  /** TOAST **/

  if (action.type === ADD_TOAST) {
    const toast = action.payload;
    toast.key = toast.key ? toast.key : Math.random().toString(16).slice(2);
    toast.duration = (toast.duration) ? toast.duration : 5000;
    return { ...state, toasts: [toast, ...state.toasts] }
  }

  if (action.type === REMOVE_TOAST) {
    let toasts = [...state.toasts];
    const index = toasts.findIndex( x => x.key === action.payload)
    toasts.splice(index, 1);
    return { ...state, toasts: [...toasts] };
  }

  /** POPUP **/

  if (action.type === SET_POPUP) {
    return { ...state, popup: action.payload }
  }

  if (action.type === SET_STORE_POPUP) {
    return { ...state, storePopup: action.payload }
  }

  /** GENERAL **/

  if (action.type === SET_ALLOW_ACCESS) {
    return { ...state, allowAccess: action.payload } //clickDoubleTap
  }

  /** TAB BAR **/

  if (action.type === SET_TAB_BAR) {
    return { ...state, tabBar: action.payload }
  }
  if (action.type === RESET_TAB_BAR) {
    return { ...state, tabBar: { left: null, right: null } }
  }

  /** SPLASH **/

  if (action.type === SET_SPLASH_STATE) {
    return { ...state, splashState: action.payload }
  }

  if (action.type === SET_SPLASH_LOADING) {
    return { ...state, splashLoading: action.payload }
  }

  if (action.type === SET_SPLASH_ERROR) {
    return { ...state, splashState: true, error: action.payload }
  }

  if (action.type === SET_BROWSER_OPTIMAL) {
    return { ...state, isBrowserOptimal: action.payload }
  }

  if (action.type === SET_BANNER_BROWSER) {
    return { ...state, bannerBrowser: action.payload }
  }

  return state;
};

export default rootReducer;
